module.exports = __webpack_public_path__ + "assets/img/close-blue-dark.18cf0f66.svg";